export default "__VITE_ASSET__DyIIg1fv__"